import axios, {AxiosError} from 'axios';

import { PATH, SERVER_URL} from "./enpoints";

interface CallData {
  method: 'GET' | "POST" | 'DELETE' | 'PUT' | 'PATCH';
  path: string;
  data?: any;
  options?:any;
}

export async function call(param:CallData){
  const token = localStorage.getItem('token') || null;
  let headers:any = {};

  if(token){
    headers["Authorization"] = `Bearer ${token}`
  }

  if(param?.options?.headers){
    headers = {
      ...headers,
      ...(param?.options?.headers || {})
    }
  }

  let axiosOption = {
    url: param.path,
    method: param.method,
    baseURL: SERVER_URL,
    headers,
    data: param.data,
  };

  try {
    const r = await axios(axiosOption);

    return r.data;
  } catch (err:any) {
    console.log(err)
    if (err?.response?.status === 401) {
      if (window) {
        // if (process.env.NODE_ENV !== 'development') {
        //   window.location.replace('/auth/login');
        // }
        window.location.replace('/auth/login');

      } else {
        console.error('Failed to redirect: Unauthorised A');
      }
    }
    throw err;
  }

}

export {
  PATH,
  SERVER_URL
}